import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBadge = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 129, viewBox: "0 0 26 129", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 8.5L1 0.999999L1 119.5L13 128.322L25 119.5L25 1L13 8.5Z", fill: "#F7F7F7", stroke: "#1D4477" }));
const ForwardRef = forwardRef(SvgArrowBadge);
export default ForwardRef;
